import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';

export class KeywordsDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.KEYWORDS, apiHelper);
  }
}
